import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { UserChangePasswordModel } from '../../../models/user/userChangePasswordModel';
import { Link } from "react-router-dom";
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  history: any,
  onCancelClick: any;
}

interface IState {
  isLoading: boolean;
  user: UserChangePasswordModel;
  userId: number;
}

class UserChangePasswordTab extends React.Component<IProps, IState> {

  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    let profile = this.authService.getProfile();
    let userId = profile ? profile['id'] : 0;

    this.state = {
      isLoading: false,
      user: new UserChangePasswordModel(),
      userId: userId
    };
  }

  handleChange = (key, value) => {
    const user: UserChangePasswordModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  isValidAddEditForm() {
    let message = '';

    const { user } = this.state;

    if (!user.oldPassword || user.oldPassword.trim() == '') {
      message += Translate('Please enter Old Password') + ". ";
    }

    if (!user.newPassword || user.newPassword.trim() == '') {
      message += Translate('Please enter New Password') + ". ";
    }

    if (!user.confirmPassword || user.confirmPassword.trim() == '') {
      message += Translate('Please enter Confirm Password') + ". ";
    }

    if (user.newPassword && user.newPassword.trim() != '' &&
      user.confirmPassword && user.confirmPassword.trim() != '' &&
      user.newPassword != user.confirmPassword) {
      message += Translate('New Password and Confirm Password are different') + ". ";
    }

    message ? this.growl.show({ severity: 'error', summary: message }) : null;

    return message == '';
  }

  handleChangeButtonClick = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const { user, userId } = this.state;

    user.userId = userId;

    this.userService.changePassword(user).then(
      (data: any) => {
        if (data) {
          let user = this.state.user;
          user.oldPassword = '';
          user.newPassword = '';
          user.confirmPassword = '';
          this.setState({
            isLoading: false,
            user: user
          });
          this.growl.show({ severity: 'success', summary: Translate('You have successfully changed your Password.') });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });

  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleChangeButtonClick(e);
    }
  }

  public render() {
    const { isLoading, user } = this.state;

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <div>
          <div>

            <div className="p-g p-fluid">
              <div className="p-g-12 p-md-12">
                <TextField
                  type="password"
                  name="oldPassword"
                  label={Translate('Old Password')}
                  onKeyPress={this.handleKeyPress}
                  onChange={(e) => this.handleChange('oldPassword', e.target['value'])}
                  value={user && user.oldPassword ? user.oldPassword : ""}
                />
              </div>
              <div className="p-g-12 p-md-12">
                <TextField
                  type="password"
                  name="newPassword"
                  label={Translate('New Password')}
                  onKeyPress={this.handleKeyPress}
                  onChange={(e) => this.handleChange('newPassword', e.target['value'])}
                  value={user && user.newPassword ? user.newPassword : ""}
                />
              </div>
              <div className="p-g-12 p-md-12">
                <TextField
                  type="password"
                  name="confirmPassword"
                  label={Translate('Confirm Password')}
                  onKeyPress={this.handleKeyPress}
                  onChange={(e) => this.handleChange('confirmPassword', e.target['value'])}
                  value={user && user.confirmPassword ? user.confirmPassword : ""}
                />
              </div>
            </div>
            <div style={{ padding: '10px 9px', textAlign: 'right' }}>
              <Button variant="contained" size="small" onClick={this.props.onCancelClick} style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                {Translate('Cancel')}
              </Button>
              <Button variant="contained" size="small" color="primary" onClick={this.handleChangeButtonClick}>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                {Translate('Change')}
              </Button>
              {/* <Button label={Translate('Change')} onClick={this.handleChangeButtonClick} className="p-button-raised" style={{ marginRight: '10px' }} /> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UserChangePasswordTab;